<div *ngIf="isLoading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<mat-card class="content-card">
  <mat-card-header>
    <mat-card-title>
      <h5>Card Renewal Batch</h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="list-item" fxLayout="row" *ngFor="let col of importCols">
      <label fxFlex="35" class="secondary">{{ col.header }}</label>
      <label fxFlex="65" *ngIf="import">{{ col.cell(import) }}</label>
    </div>

    <br />

    <span (click)="returnBack()" style="cursor: pointer">◀️ Go back</span>
    <span>&nbsp;&nbsp;</span>
    <button *ngIf="canSeeDownloadCsvButton()"
            title="Please verify configuration settings or contact administrator for aditional support"
            mat-raised-button
            color="primary"
            (click)="downloadGeneratedCsv()"
            [disabled]="!import || import.cardRenewals.length === 0">
      Download Generated CSV
    </button>

  </mat-card-content>
</mat-card>
<div *ngIf="isImporting">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div *ngIf="import">
  <mat-card class="content-card">
    <mat-card-header>
      <mat-card-title>
        <h5>Upload Renewal Results CSV (from Portal)</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-file-upload *appHasRoles="['admin']" (upload)="onUploadImportCsv($event)"></app-file-upload>
    </mat-card-content>
  </mat-card>


  <mat-card class="content-card" *ngIf="import.importErrors.length > 0">
    <mat-card-header>
      <mat-card-title>
        <h5>Import errors</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-mat-table-generator #importErrorsTable
                               tableName="importErrorsTable"
                               [columns]="importErrorsCols"
                               [dataSource]="importErrorsDataSource"
                               [multiselectEnabled]="false">
      </app-mat-table-generator>
    </mat-card-content>
  </mat-card>



  <mat-card class="content-card" *ngIf="import.cardRenewals.length > 0">
    <mat-card-header>
      <mat-card-title>
        <h5>Import data</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-mat-table-generator #importDataTable
                               tableName="importDataTable"
                               [columns]="importDataCols"
                               [dataSource]="importDataDataSource"
                               [multiselectEnabled]="false"
                               [viewLink]="getViewLink">
      </app-mat-table-generator>
    </mat-card-content>
  </mat-card>
</div>
